import React from "react";
import {Button, ControlLabel, Form, FormControl, FormGroup} from "react-bootstrap";

class FulltextSearchForm extends React.Component {
    render() {
        return (
            <Form inline className="pull-right" onSubmit={this.props.handleSubmit}>
                <FormGroup>
                    <ControlLabel>{this.props.label}</ControlLabel>
                    {' '}
                    <FormControl type="text" placeholder={this.props.placeholder} onChange={this.props.handleChange}/>
                </FormGroup>
                {' '}
                <Button type="submit" className="btn-primary">
                    Vyhledat
                </Button>
            </Form>
        );
    }
}

export default FulltextSearchForm;


/** WEBPACK FOOTER **
 ** ./src/components/Forms/FulltextSearchForm.js
 **/